import axios from 'axios'
import React, { useState } from 'react'
import authService from '../../../Components/Login/auth.service'
import '../../../styles/pages/MenuDireito/modal/ModalFuncaoEPermissao.css'
//const uuidv4 = require('uuid/v4')

export default function ModalFuncaoEPermissao() {
  const uuidv4 = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(16) + '-' + Math.random().toString(16).slice(2);
  var user = authService.getCurrentUser()
  const [modal, setModal] = useState(false)

  const toggleModal = () => {
    setModal(!modal)
  }

  if (modal) {
    var user = authService.getCurrentUser()
    document.body.classList.add('active-modal')
  } else {
    document.body.classList.remove('active-modal')
  }

  function handleInputChange(event) {
    if (event.target.name === 'fncStatus') {
      if (event.target.checked) {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    } else {
      campos[event.target.name] = event.target.value
    }
    setCampos(campos)
  }
  let newDate = new Date()
  const [campos, setCampos] = useState({
    IdFuncao: 0,
    IdEmpresa: user[0].IdEmpresa,
    fncDescricao: '',
    fncObservacoes: '',
    fncStatus: 1,
    fncCriadoPor: user[0].pesEmail,
    fncCriadoEm: newDate,
    fncAlteradoPor: user[0].pesEmail,
    fncAlteradoEm: newDate,
    fncCodigoGUID: uuidv4
  })
  function handleFormSubmit(event) {
    event.preventDefault()
    axios
      .post(process.env.REACT_APP_API_URL + '/api/v1/funcao', campos)
      .then(response => {
        alert(response.data.message)
        window.location.reload()
      })
  }

  return (
    <>
      <button onClick={toggleModal} className="buttonModalPadraoPes">
        Nova Função
      </button>

      {modal && (
        <div className="modalEquipe">
          <div onClick={toggleModal} className="overlay"></div>
          <div className="modalPadrao-content">
            <div className="cxTituloPadrao">
              <h1>
                Nova Função
                <hr className="hrTitleModal" />
              </h1>
              <button onClick={toggleModal}>X</button>
            </div>
            <form onSubmit={handleFormSubmit}>
              <label>Descrição:</label>
              <input
                type="text"
                id="fname"
                defaultValue={campos.fncDescricao}
                name="fncDescricao"
                onChange={handleInputChange}
              ></input>
              <label>Observação:</label>
              <textarea
                type="text"
                id="fname"
                defaultValue={campos.fncObservacoes}
                name="fncObservacoes"
                onChange={handleInputChange}
                row="none"
                maxLength="500"
              ></textarea>
              <div className="caixaSalvarPadrao">
                <div className="InputAuthorization4">
                  <label>
                    <input
                      name="txtStatus"
                      type="checkbox"
                      defaultChecked={!!campos.fncStatus}
                      onChange={handleInputChange}
                    />
                    <span>Status</span>
                  </label>
                </div>
                <button type="submit">Salvar Registro</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  )
}
